module.exports = __webpack_public_path__ + "2d6a9f05418352f701eda10e0ff038b3.png";